export enum INSURANCE_PROVIDER_TYPE {
  DENTAL = 'D',
  MEDICAL = 'M',
  UNSPECIFIED = 'UN',
}
